import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(2),
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  list: {
    marginLeft: theme.spacing(2),
  },
  item: {
    padding: theme.spacing(1),
  },
});

const View = ({ classes, documents }) => {
  if (documents.length === 0) {
    return null;
  }
  return (
    <Box className={classes.root} debugColor="chartreuse">
      <Typography
        variant="h3"
        color="primary"
        className={classes.title}
      >
        Requested Documents
      </Typography>
      <Box debugColor="crimson" className={classes.list}>
        {documents.map(document => (
          <Typography variant="h5" className={classes.item}>{document}</Typography>
        ))}
      </Box>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  documents: PropTypes.array,
};
View.defaultProps = {
  documents: [],
};

export default withStyles(styles)(View);
